import commonUtil from '../../../../../utils/commonUtil';

export const DELIVERY_ADDRESS_LOAD = 'DELIVERY_ADDRESS_LOAD';
export const DELIVERY_ADDRESS_LOAD_SUCCESS = 'DELIVERY_ADDRESS_LOAD_SUCCESS';
export const DELIVERY_ADDRESS_LOAD_FAIL = 'DELIVERY_ADDRESS_LOAD_FAIL';

export const ADD_NEW_ADDRESS_LOAD = 'ADD_NEW_ADDRESS_LOAD';
export const ADD_NEW_ADDRESS_LOAD_SUCCESS = 'ADD_NEW_ADDRESS_LOAD_SUCCESS';
export const ADD_NEW_ADDRESS_LOAD_FAIL = 'ADD_NEW_ADDRESS_LOAD_FAIL';

export const POSTAL_ADDRESS_SEARCH_LOAD = 'POSTAL_ADDRESS_SEARCH_LOAD';
export const POSTAL_ADDRESS_SEARCH_LOAD_SUCCESS = 'POSTAL_ADDRESS_SEARCH_LOAD_SUCCESS';
export const POSTAL_ADDRESS_SEARCH_LOAD_FAIL = 'POSTAL_ADDRESS_SEARCH_LOAD_FAIL';

export const ADDRESS_SEARCH_LOAD = 'ADDRESS_SEARCH_LOAD';
export const ADDRESS_SEARCH_LOAD_SUCCESS = 'ADDRESS_SEARCH_LOAD_SUCCESS';
export const ADDRESS_SEARCH_LOAD_FAIL = 'ADDRESS_SEARCH_LOAD_FAIL';

export const STATE_LIST = 'STATE_LIST';
export const STATE_LIST_SUCCESS = 'STATE_LIST_SUCCESS';
export const STATE_LIST_FAIL = 'STATE_LIST_FAIL';

// export const UPDATE_ADDRESS = 'UPDATE_ADDRESS';

export const RESET_ADDRESS_OF_POSTALCODE = 'RESET_ADDRESS_OF_POSTALCODE';

export const FLUSH_ADDRESS_SEARCH = 'FLUSH_ADDRESS_SEARCH';

export const GIFT_REGISTRY_ADDRESS_LOAD = 'GIFT_REGISTRY_ADDRESS_LOAD';
export const GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS = 'GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS';
export const GIFT_REGISTRY_ADDRESS_LOAD_FAIL = 'GIFT_REGISTRY_ADDRESS_LOAD_FAIL';

export const EVENT_MANAGEMENT_ADDRESSES_UPDATE = 'EVENT_MANAGEMENT_ADDRESSES_UPDATE';
export const EVENT_MANAGEMENT_ADDRESSES_RESET = 'EVENT_MANAGEMENT_ADDRESSES_RESET';

export function isDeliveryAddressLoaded(globalState) {
  return globalState.deliveryAddress && globalState.deliveryAddress.loaded;
}

export function getDeliveryAddressInfo(eventId) {
  console.log('getDeliveryAddressInfo called with eventId:', eventId);
  const payload = {};
  payload.brand = commonUtil.getBrand();
  payload.channel = commonUtil.getChannel();
  payload.eventId = eventId;
  return {
    types: [DELIVERY_ADDRESS_LOAD, DELIVERY_ADDRESS_LOAD_SUCCESS, DELIVERY_ADDRESS_LOAD_FAIL],
    promise: client => client.post('/api/EventDeliveryAddresses', {
      data: (payload),
    }), // params not used, just shown as demonstration
  };
}

export function updateEventDeliveryAddress(addressDetail, eventID, profileId) {
  //this is used to set the address as default ,
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase(); 
  // payload.profileId = profileId;
  payload.eventId = eventID;
  payload.addressInfo = addressDetail;  

  return commonUtil.triggerServerRequest({
    url: '/api/EditEvent/addDeliveryAddressToEvent',
    method: 'POST',
    data: payload,
  });
}

// for Address Celebrity Mapping
export function hanldeAddressCelebrityMapping(ownerDeliveryMapping) {
  const payload = ownerDeliveryMapping;
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  return commonUtil.triggerServerRequest({ url: '/api/EditEvent/AddressCelebrityMapping', method: 'POST', data: payload });
}

export function getAddressData(userDetail) {
  const payload = userDetail;
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  return {
    types: [ADDRESS_SEARCH_LOAD, ADDRESS_SEARCH_LOAD_SUCCESS, ADDRESS_SEARCH_LOAD_FAIL],
    promise: client => client.post('/api/EditEvent/addressSearch', {
      data: (payload),
    }),
  };
}

export function resetAddress() {
  return {
    type: RESET_ADDRESS_OF_POSTALCODE,
  };
}
// For  Add Event Delivery Address
export function addEventDeliveryAddress(addressDetail, eventId, profileId, ecommAddressId) {
  const payload = {};
  payload.brand = commonUtil.getBrand().toUpperCase();
  payload.channel = commonUtil.getChannel().toUpperCase();
  payload.profileId = profileId;
  payload.eventId = eventId;
  payload.ecommAddressId = ecommAddressId;
  payload.celebrityName = addressDetail.celebrityName;
  payload.nickname = addressDetail.nickname;
  payload.firstName = addressDetail.firstName;
  payload.middleName = addressDetail.middleName;
  payload.lastName = addressDetail.lastName;
  payload.maternalName = addressDetail.maternalName;
  payload.country = addressDetail.country;
  payload.city = addressDetail.city;
  payload.stateId = addressDetail.stateId;
  payload.state = addressDetail.state;
  payload.delegationMunicipality = addressDetail.delegationMunicipality;
  payload.delegationMunicipalityId = addressDetail.delegationMunicipalityId;
  payload.building = addressDetail.building;
  payload.postalCode = addressDetail.postalCode;
  payload.neighbourhood = addressDetail.neighbourhood;
  payload.neighbourhoodId = addressDetail.neighbourhoodId;
  payload.address1 = addressDetail.address1;
  payload.address2 = addressDetail.address2;
  payload.address3 = addressDetail.address3;
  payload.exteriorNumber = addressDetail.exteriorNumber;
  payload.interiorNumber = addressDetail.interiorNumber;
  payload.particularPhoneCode = addressDetail.particularPhoneCode;
  payload.phoneNumber = addressDetail.phoneNumber;
  payload.businessPhoneCode = addressDetail.businessPhoneCode;
  payload.businessPhoneNumber = addressDetail.businessPhoneNumber;
  payload.cellular = addressDetail.cellular;
  payload.otherColony = addressDetail.otherColony;

  return commonUtil.triggerServerRequest({
    url: '/api/EditEvent/EventDeliveryAddress',
    method: 'POST',
    data: payload,
  });
}


// export function getState() {
//   const payload = {};
//   payload.brand = commonUtil.getBrand();
//   payload.channel = commonUtil.getChannel();
//   return {
//     types: [STATE_LIST, STATE_LIST_SUCCESS, STATE_LIST_FAIL],
//     promise: client => client.post('/api/EventCreation/stateList', {
//       payload,
//     }),
//   };
// }


export function getState() {
  const data = {};
  data.brand = commonUtil.getBrand();
  data.channel = commonUtil.getChannel();
  return {
    types: [STATE_LIST, STATE_LIST_SUCCESS, STATE_LIST_FAIL],
    promise: client => client.post('/api/EventCreation/stateList', {
      data,
    }),
  };
}

export const flushAddressSearch = () => (dispatch, getstate) => {
  const state = getstate();
  const pageDate = state.deliveryAddress && state.deliveryAddress.addrSearchData && state.deliveryAddress.addrSearchData.addrSearchResponse ? state.deliveryAddress.addrSearchData.addrSearchResponse : '';
  Object.keys(pageDate).map((p) => {
    if (typeof pageDate[p] === 'object' && p !== 'data') {
      delete pageDate[p];
    }
    return undefined;
  });
  dispatch({
    type: FLUSH_ADDRESS_SEARCH,
    data: pageDate,
  });
};

export function loadProfileAddress() {
  const _giftRegistryInput = {};
  _giftRegistryInput.brandName = commonUtil.getBrand();
  _giftRegistryInput.channel = commonUtil.getChannel().toUpperCase();

  return {
    types: [GIFT_REGISTRY_ADDRESS_LOAD, GIFT_REGISTRY_ADDRESS_LOAD_SUCCESS, GIFT_REGISTRY_ADDRESS_LOAD_FAIL],
    promise: client => client.post('/api/currentUser/getAddresses', {
      data: (_giftRegistryInput),
    }),
    // TODO: This is local srvice.
    // promise: client => client.get('/api/giftRegistryAddress'),
  };
}

export function updateEventManagementAddresses(addresses) {
  return {
    type: EVENT_MANAGEMENT_ADDRESSES_UPDATE,
    payload: addresses,
  };
}

export function resetEventManagementAddresses() {
  return {
    type: EVENT_MANAGEMENT_ADDRESSES_RESET,
  };
}